import type { ReactToPhaserEvent } from 'Phaser/EventBus2';
import Tutorial, { ChapterType, Timestamp } from 'Types/ExerciseData';

type Chapter = {
  start: Timestamp;
  title: string;
  events: { at: string; phaserEvent: ReactToExerciseEvent }[];
};

export type Timestamps = {
  videoEnd: Timestamp;
  chapters: Chapter[];
};

/*function toProperTimestamp(timestamp: string): Timestamp {
  const [_, m, s, f] = timestamp.split(':').map(x => parseInt(x));
  const s_dec = f / 60.0;
  return `${m}:${s + s_dec}`;
}*/

export function AddEventsAndMergeTimestamps(
  { videoEnd, chapters }: Timestamps,
  tutorial: Tutorial,
): Tutorial {
  let chapterIdx = 0;
  let sectionIdx = 0;
  let nextSectionThreshold = tutorial.sections[sectionIdx].chapters.length;
  //const { videoEnd, chapters } = GenerateTimestamps(input);
  chapters.forEach((chapter) => {
    tutorial.sections[sectionIdx].chapters[chapterIdx].start = chapter.start;
    tutorial.sections[sectionIdx].chapters[chapterIdx].title = chapter.title;
    if (tutorial.sections[sectionIdx].chapters[chapterIdx].data[0] === ChapterType.Exercise) {
      tutorial.sections[sectionIdx].chapters[chapterIdx].data[1]!.events = chapter.events.map(
        ({ at, phaserEvent }) => ({
          at: at as Timestamp,
          phaserEvent,
          pause: phaserEvent[0] === 'StartExercise' || phaserEvent[0] === 'start-exercise',
        }),
      );
    }

    chapterIdx++;
    if (chapterIdx >= nextSectionThreshold) {
      chapterIdx = 0;
      sectionIdx++;
      nextSectionThreshold = tutorial.sections.at(sectionIdx)?.chapters.length ?? 0;
    }
  });
  tutorial.end = videoEnd;
  return tutorial;
}

/*function GenerateTimestamps(input: string) {
  type Chapter = {
    start: Timestamp,
    title: string,
    events: { at: Timestamp, phaserEvent: ReactToExerciseEvent }[]
  };
  let videoEnd: Timestamp;
  const regex = /^(\d+:\d+:\d+:\d+) (\w+) (.*)$/;
  let chapterIdx = -1;
  const chapters: Chapter[] = [];
  input.split('\n').forEach(line => {
    const matches = line.match(regex);
    if (matches) {
      const [_, timestamp, event, data] = matches;
      const timestampInSecs = toProperTimestamp(timestamp);
      const payload = (data === "guide" || data === "Marker") ? undefined : data;
      switch (event) {
        case "ChapterStart": {
          chapterIdx += 1;
          chapters[chapterIdx] = {
            start: timestampInSecs,
            title: data,
            events: [],
          };
          break;
        }
        case "UpdateObjective": {
          chapters[chapterIdx].events.push({
            at: timestampInSecs,
            phaserEvent: UpdateObjective(payload)
          });
          break;
        }
        case "StartExercise": {
          chapters[chapterIdx].events.push({
            at: timestampInSecs,
            phaserEvent: StartExercise()
          });
          break;
        }
        case "VideoEnd": {
          videoEnd = timestampInSecs;
          break;
        }
        default:
          console.error(`Line is malformed: ${line}; Unknown Event Type: ${event}`);
          return;
      }
    }
  });
  return {
    chapters,
    videoEnd: videoEnd!
  }
}*/
